import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { admin, AdminMailbox } from "../../api/client";
import { fmtDate, PageHeader, useFlash } from "./common";

export default function Mailboxes() {
  const [rows, setRows] = useState<AdminMailbox[]>([]);
  const [failingOnly, setFailingOnly] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [toast, setToast] = useState<string | null>(null);
  const flash = useFlash(setToast);

  const load = () => admin.mailboxes(failingOnly).then(setRows).catch((e) => setError(e.message));
  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [failingOnly]);

  async function poll(m: AdminMailbox) {
    await admin.pollMailbox(m.id);
    flash(`Queued a check of ${m.email_address}.`);
    load();
  }

  async function toggle(m: AdminMailbox) {
    await admin.updateMailbox(m.id, { is_active: !m.is_active });
    load();
  }

  return (
    <div className="page">
      <PageHeader title="Mailboxes" sub="Every connected inbox across all users." />
      <div className="filter-bar">
        <label style={{ display: "flex", flexDirection: "row", gap: 8, margin: 0, fontWeight: 400 }}>
          <input type="checkbox" checked={failingOnly} onChange={(e) => setFailingOnly(e.target.checked)} style={{ width: "auto", margin: 0 }} />
          Only failing
        </label>
        <button className="btn btn-ghost btn-sm" onClick={load}>Refresh</button>
      </div>
      {error && <div className="page-error">{error}</div>}
      <table className="data-table">
        <thead>
          <tr>
            <th>Mailbox</th>
            <th>Owner</th>
            <th>Provider</th>
            <th>Emails</th>
            <th>Last checked</th>
            <th>Status</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {rows.map((m) => (
            <tr key={m.id}>
              <td>{m.email_address}</td>
              <td>{m.owner_email}</td>
              <td>{m.provider}</td>
              <td>{m.message_count}</td>
              <td>{m.last_poll_started_at ? "checking now…" : fmtDate(m.last_polled_at)}</td>
              <td>
                {!m.is_active ? (
                  <span className="muted">Paused</span>
                ) : m.last_error ? (
                  <span style={{ color: "var(--danger)" }} title={m.last_error}>
                    {m.consecutive_failures} failure{m.consecutive_failures === 1 ? "" : "s"}: {m.last_error.slice(0, 80)}
                  </span>
                ) : (
                  "OK"
                )}
              </td>
              <td style={{ whiteSpace: "nowrap", textAlign: "right" }}>
                <button className="btn btn-ghost btn-sm" onClick={() => poll(m)}>Check now</button>
                <button className="btn btn-ghost btn-sm" onClick={() => toggle(m)}>{m.is_active ? "Pause" : "Resume"}</button>
                <Link className="btn btn-ghost btn-sm" to={`/admin/messages?owner_user_id=${m.owner_user_id}`}>Emails</Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {toast && <div className="toast">{toast}</div>}
    </div>
  );
}
